import React from "react";

import OrdersSectionItemWrapper from "./components/OrdersSectionItemWrapper";

const OrdersSectionItem = ({ children, ...rest }) => {
  return <OrdersSectionItemWrapper {...rest}>{children}</OrdersSectionItemWrapper>;
};

export default OrdersSectionItem;
